import { bl_ppl_to_xap_doc_hdr_RowClass, bl_ppl_to_xap_doc_line_RowClass } from '../../../dbschema';
import { BaseContainerModel } from  '../../base-container.model';

export class PeppolToXAPDocHdrLineContainerModel extends BaseContainerModel {
    bl_ppl_to_xap_doc_hdr: bl_ppl_to_xap_doc_hdr_RowClass = new bl_ppl_to_xap_doc_hdr_RowClass();
    bl_ppl_to_xap_doc_lines: bl_ppl_to_xap_doc_line_RowClass[] = [];
}
